import IconButton from '@mui/material/IconButton'
import RemoveIcon from '@mui/icons-material/Remove'
import { reExportedColors, ITooltip } from '../../index'

const MinusIconButton = ({ onClick, className, disabled, sx }) => (
  <ITooltip placement='top' content='Hide'>
    <IconButton
      className={className}
      disabled={disabled}
      onClick={onClick}
      sx={[
        {
          background: reExportedColors.LIGHT_GREY,
          border: `2px solid ${reExportedColors.LIGHT_GREY}`,
          '&:hover': { border: '2px solid #fff' },
          '& .MuiSvgIcon-root': { color: reExportedColors.DARK_GREY }
        },
        ...(Array.isArray(sx) ? sx : [sx]).filter(Boolean)
      ]}
    >
      <RemoveIcon />
    </IconButton>
  </ITooltip>
)

export default MinusIconButton
